import React from "react";
import * as S from "./styles";
export var RightCaret = function RightCaret(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 24",
    "aria-hidden": "true"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    transform: "translate(-327 -234)"
  }, React.createElement("path", {
    strokeWidth: "2",
    d: "M1.87 1.846L11.221 12.027 1.87 22.154",
    transform: "translate(327 234)"
  })));
};